import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UnionPayInfoComponent} from "./union-pay-info.component";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzUploadModule} from "ng-zorro-antd/upload";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzFormModule,
        NzInputModule,
        NzUploadModule,
    ],
    exports: [
        UnionPayInfoComponent,
    ],
    declarations: [
        UnionPayInfoComponent,
    ],
})
export class UnionPayInfoModule {
}
